'use client';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Box, Input, Stack, Text } from '@chakra-ui/react';
import { CField } from '../../../CField';
import { IUser } from '@/_store/types';

interface IProps {
  formData: IUser;
  errors: { name?: string };
  loading: boolean;
  onChange: (value: string, name: string) => void;
}

function RegisterDesktop({ formData, errors, loading, onChange }: IProps) {
  const [acceptPolicy, setAcceptPolicy] = useState(true);

  const t = useTranslations();

  return (
    <Box>
      <Stack pt={0} gap={2}>
        <Text fontSize='2xl' color={'text'} fontWeight={600} textAlign='start'>
          {t('registration')}
        </Text>
        <Text fontSize='sm' color='gray.800' textAlign='start'>
          {t('registration_description')}
        </Text>
      </Stack>
      <Stack gap={4} my={5}>
        <CField label={t('your_name')} bgColor='background' color={'text'}>
          <Input
            placeholder=''
            className='peer'
            value={formData.name}
            onChange={(e) => onChange(e.target.value, 'name')}
            borderColor={errors.name ? 'red.500' : 'inherit'}
          />
          {errors.name && (
            <Text color='red.500' fontSize='sm'>
              {errors.name}
            </Text>
          )}
        </CField>
        <CField label={t('birthday')} bgColor='background' color={'text'}>
          <Input
            type='date'
            placeholder=''
            className='peer'
            color={'text'}
            value={formData?.date_of_birth || ''}
            onChange={(e) => onChange(e.target.value, 'date_of_birth')}
          />
        </CField>
      </Stack>
      <Button
        mt={3}
        type='submit'
        size='xl'
        w='full'
        height='56px'
        fontWeight={600}
        fontSize='md'
        bg='primary'
        color='primary.text'
        _hover={{
          bg: 'primary.hover',
        }}
        loading={loading}
        disabled={!acceptPolicy}
      >
        {t('save')}
      </Button>
    </Box>
  );
}

export default RegisterDesktop;
